export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14310.910f0dcf.jpg";